import { render, staticRenderFns } from "./NormalSingle4.vue?vue&type=template&id=f7942a34&"
import script from "./NormalSingle4.vue?vue&type=script&lang=js&"
export * from "./NormalSingle4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports